module.exports = __webpack_public_path__ + "fonts/ralewaylight.50f3fba.ttf";